import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// 1. Define User interface matching your API 'data' object
export interface User {
  id: number;
  userName: string;
  emailAddr: string;
  roles: string; // e.g. "AGENCY_OWNER"
  isEmailVerified: boolean;
  agencyUserId: number;
  agencyUuid?: string; // e.g. "RH6545CT"
  skipPage?: string; // e.g. "PROFILE"
  isCompanyExists: boolean;
  // Add other fields from response if needed (timezone, etc.)
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  user: null,
  token: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{ user: User; token: string }>,
    ) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      sessionStorage.clear(); // Clear storage on logout
      localStorage.clear();
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
